<!-- SUCCESS -->
@if (isAccepted) {
  <div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <div class="col-md-8 col-lg-5">
      <div class="text-center mb-4">
        <img src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4"
          alt="Sigvaris Group Logo" class="img-fluid mb-3" style="max-width: 200px; height: 120px;">
      </div>
      <div class="card">
        <div class="card-body text-center p-5">
          <h2 class="card-title mb-3">Invite Accepted</h2>
          <p class="lead">You have been successfully added to the clinic.</p>
          <p class="text-secondary">You can now log in and select this clinic when creating an order.</p>
          <p class="text-muted mt-3">Redirecting to login in {{ countdown }} seconds...</p>
        </div>
      </div>
    </div>
  </div>
}

<!-- LOADING -->
@if (isLoading && !isAccepted) {
  <div class="position-fixed top-50 start-50 translate-middle">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
}

<!-- FORM -->
@if (!isAccepted && !isLoading) {
  <div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
    <div class="col-md-8 col-lg-5">
      <div class="text-center mb-4">
        <img src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4"
          alt="Sigvaris Group Logo" class="img-fluid mb-3" style="max-width: 200px; height: 120px;">
      </div>
      <div class="card">
        <div class="card-body p-5">
          <h2 class="card-title text-center mb-4">Clinic Invite</h2>

          @if (therapistName) {
            <p class="mb-2"><strong>Name:</strong> {{ therapistName }}</p>
          }
          @if (clinicCode) {
            <p class="mb-4"><strong>Clinic:</strong> {{ clinicCode }}</p>
          }

          <p class="text-secondary mb-4">
            You have been invited to join a new clinic. Click below to confirm.
          </p>

          @if (errorMessage) {
            <div class="alert alert-danger">{{ errorMessage }}</div>
          }

          @if (!inviteToken) {
            <div class="alert alert-warning">Invalid or missing invite link.</div>
          } @else {
            <div class="d-grid">
              <button type="button" class="btn btn-primary btn-lg" (click)="acceptInvite()">
                Accept Invite
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
